import React, { useEffect, useContext, useState, useRef } from "react";
import { useHistory } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  tableLoading,
  formatPrice,
  getSystemSettings,
  customStyle,
} from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "react-moment";
import moment from "moment";
import Select from "react-select";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useReactToPrint } from "react-to-print";

//pages & includes
import ReportSidebar from "./ReportSidebar";

//context consumer
import { SettingsContext } from "../../../../contexts/Settings";
import { UserContext } from "../../../../contexts/User";
import { RestaurantContext } from "../../../../contexts/Restaurant";
import CustomSpinLoader from "../../../components/CustomSpinLoader";
import ReportTypeOptions from "../../../components/Reports/ReportTypeOptions";
import ReportExcelPrintGap from "../../../components/Reports/ReportExcelPrintGap";

let groupArr = [
  { id: 1, name: "Document No" },
  { id: 2, name: "Document Date" },
  { id: 3, name: "Supplier" },
  { id: 4, name: "Branch" },
];

const postOptions = [
  {
    id: "",
    name: "All"
  },
  {
    id: 0,
    name: "Un Post"
  },
  {
    id: 1,
    name: "Post"
  }
]

const FgPurchaseReport = () => {
  const { t } = useTranslation();
  // const history = useHistory();
  //getting context values here
  let {
    loading,
    setLoading,
    dataPaginating,
    setDataPaginating,
    generalSettings,
  } = useContext(SettingsContext);
  const { supplierForSearch, getSupplier } = useContext(UserContext);
  let {
    branchForSearch,
  } = useContext(RestaurantContext);

  //all data
  const [reportData, setReportData] = useState(null);
  const componentRef = useRef();
  const componentRefThermal = useRef();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [branch, setBranch] = useState(null);
  const [supplier, setSupplier] = useState(null);
  const [group, setGroup] = useState(groupArr[3]);
  const [isPost, setIsPost] = useState(postOptions[0]);
  const [generatedReport, setGeneratedReport] = useState(false);
  const [option, setOption] = useState("excel");
  const [reportOption,setReportOption] = useState("detail")

  useEffect(() => {
    if (!supplierForSearch) {
      getSupplier();
    }

    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [generalSettings]);

  let common_toast = {
    position: "bottom-center",
    closeButton: false,
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    className: "text-center toast-notification",
  };

  const handleSetType = (e)=>{
    setReportOption(e.target.value)
  }

  const handleBranch = (branch) => {
    setBranch(branch);
  };

  const handleSetOption = (value)=>{
    setIsPost(value)
  }

  const handleOption = (e) => {
    setOption(e.target.value);
  };

  const handleSupplier = (supp) => {
    setSupplier(supp);
  };

  const thermalPrint = useReactToPrint({
    content: () => componentRefThermal.current,
    pageStyle: `
        @page {
          margin: 15px 7px;
        }
      `,
  });

  //get excel reports filter
  const getExcelReport = () => {
    setReportData(null);
    setGeneratedReport(false);
    if (startDate !== null && endDate !== null && group !== null) {
      getReport();
    } else {
      toast.error(
        `${_t(t("Please select from date, to date and group"))}`,
        common_toast
      );
    }
  };

  //get fg purchase report
  const getReport = async () => {
    setDataPaginating(true);
    let fromDate = moment(startDate).format("YYYY-MM-DD");
    let toDate = moment(endDate).format("YYYY-MM-DD");
    const url = BASE_URL + "/settings/get-finished-good-purchase-report";
    let formData = new FormData();
    formData.append("fromDate", fromDate);
    formData.append("toDate", toDate);
    formData.append("branch_id", branch?.id ?? "");
    formData.append("type", reportOption)
    formData.append("supplier_id", supplier?.id ?? "");
    // formData.append("is_post", isPost?.id ?? "");
    formData.append("group_by", group.name);

    return axios
      .post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setGeneratedReport(true);
        setReportData(res.data);
        setDataPaginating(false);
        if (option === "excel") {
          componentRef.current.handleDownload();
        } else {
          thermalPrint();
        }
      })
      .catch((error) => {
        setDataPaginating(false);
        toast.error(`${_t(t("Please try again"))}`, common_toast);
      });
  };

  const header = [
    { name: "Group Name", key: "group_name" },
    { name: "Invoice Number", key: "invoice_number", gap:1 },
    { name: "Date", render:(item)=> <Moment format="LL">{item.purchase_date}</Moment>},
    { name: "Branch", key: "branch_name" },
    { name: "Supplier", key: "supplier_name" },
    { name: "Item Name", key: "item_name" },
    { name: "Payment Type", key: "payment_type" },
    { name: "Qty", key: "qty" },
    { name: "Rate", key:"rate", total: 1},
    { name: "Amount", key:"amount" ,total: 1},
    { name: "Discount", key:"discount" ,total: 1},
    { name: "Tax Amount", key:"tax" ,total: 1},
    { name: "Advance Tax", key:"advance_tax" ,total: 1},
    { name: "Total Amount", key:"total" ,total: 1},
  ];

  const headerSummary = [
    { name: "Group Name", key: "group_name" },
    { name: "Invoice Number", key: "invoice_number", gap:1 },
    { name: "Date", render:(item)=> <Moment format="LL">{item.purchase_date}</Moment>},
    { name: "Branch", key: "branch_name" },
    { name: "Supplier", key: "supplier_name" },
    { name: "Payment Type", key: "payment_type" },
    { name: "Amount", key:"total_amount", total: 1},
    { name: "Discount", key:"total_discount", total: 1},
    { name: "Tax Amount", key:"total_tax", total: 1},
    { name: "Advance Tax", key:"total_advance_tax", total: 1},
    { name: "Total Amount", key:"total_bill", total: 1},
    { name: "Transportation", key:"transportation", total: 1},
  ];

  return (
    <>
      <Helmet>
        <title>{_t(t("FG Purchase Report"))}</title>
      </Helmet>
      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls"
        filename={reportOption === "summary" ? "FG Purchase Summary Report" : "FG Purchase Detail Report"}
        sheet="sheet 1"
        buttonText="FG Purchase Detail"
        ref={componentRef}
      />

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ReportSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <CustomSpinLoader loading={loading || dataPaginating} />

                    {/* spin loading ends */}

                    <div key="smtp-form">
                      {/* Header Section */}
                      <div className="row gx-2 align-items-center t-pt-15 t-pb-10">
                        <div className="col-md-6">
                          <ul className="t-list fk-breadcrumb mb-0">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize font-weight-bold" style={{ fontSize: '1.1rem' }}>
                                <i className="fa fa-file-invoice mr-2"></i>
                                {_t(t("FG Purchase Report"))}
                              </span>
                            </li>
                          </ul>
                        </div>
                        <div className="col-md-6 d-flex justify-content-end">
                          <ReportTypeOptions
                            selectedOption={option}
                            onChange={handleOption}
                          />
                        </div>
                      </div>

                      <hr className="my-1" />

                      {/* Filter Card Section */}
                      <div className="mb-2">
                        <div className="p-3">
                          
                          {/* Date Range Row */}
                          <div className="row">
                            <div className="col-lg-2 col-md-3 mb-2">
                              <label className="form-label mb-1 sm-text font-weight-bold">
                                <i className="fa fa-calendar-alt mr-1 text-primary"></i>
                                {_t(t("From Date"))} <span className="text-danger">*</span>
                              </label>
                              <DatePicker
                                selected={startDate}
                                onChange={(date) => setStartDate(date)}
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                className="form-control form-control-sm"
                                placeholderText={_t(t("Select from date"))}
                                shouldCloseOnSelect={false}
                                maxDate={new Date()}
                              />
                            </div>

                            <div className="col-lg-2 col-md-3 mb-2">
                              <label className="form-label mb-1 sm-text font-weight-bold">
                                <i className="fa fa-calendar-alt mr-1 text-primary"></i>
                                {_t(t("To Date"))} <span className="text-danger">*</span>
                              </label>
                              <DatePicker
                                selected={endDate}
                                onChange={(date) => setEndDate(date)}
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                className="form-control form-control-sm"
                                placeholderText={_t(t("Select to date"))}
                                shouldCloseOnSelect={false}
                                maxDate={new Date()}
                              />
                            </div>

                            <div className="col-lg-3 col-md-6 mb-2">
                              <label className="form-label mb-1 sm-text font-weight-bold">
                                {_t(t("Branch"))}
                              </label>
                              <Select
                                options={branchForSearch ? branchForSearch : []}
                                getOptionLabel={(option) => option.name}
                                getOptionValue={(option) => option.id}
                                value={branch}
                                classNamePrefix="select"
                                isClearable
                                className="sm-text"
                                onChange={handleBranch}
                                styles={customStyle}
                                maxMenuHeight="200px"
                                placeholder={_t(t("All branches")) + ".."}
                              />
                            </div>

                            <div className="col-lg-3 col-md-6 mb-2">
                              <label className="form-label mb-1 sm-text font-weight-bold">
                                <i className="fa fa-user-tie mr-1 text-info"></i>
                                {_t(t("Supplier"))}
                              </label>
                              <Select
                                options={supplierForSearch ? supplierForSearch : []}
                                getOptionLabel={(option) => option.name}
                                getOptionValue={(option) => option.id}
                                value={supplier}
                                styles={customStyle}
                                isClearable
                                classNamePrefix="select"
                                className="sm-text"
                                onChange={handleSupplier}
                                maxMenuHeight="200px"
                                placeholder={_t(t("All suppliers")) + ".."}
                              />
                            </div>

                            <div className="col-lg-2 col-md-6 mb-2">
                              <label className="form-label mb-1 sm-text font-weight-bold">
                                <i className="fa fa-layer-group mr-1 text-warning"></i>
                                {_t(t("Group By"))} <span className="text-danger">*</span>
                              </label>
                              <Select
                                options={groupArr && groupArr}
                                getOptionLabel={(option) => option.name}
                                getOptionValue={(option) => option.id}
                                value={group}
                                styles={customStyle}
                                isClearable
                                classNamePrefix="select"
                                className="sm-text"
                                onChange={(group) => setGroup(group)}
                                maxMenuHeight="200px"
                                placeholder={_t(t("Select group")) + ".."}
                              />
                            </div>
                          </div>

                          {/* Report Type & Action Row */}
                          <div className="row align-items-center mt-3 pt-3 border-top">
                            <div className="col-lg-4 col-md-5 mb-2">
                              <label className="form-label mb-2 sm-text font-weight-bold d-block">
                                <i className="fa fa-list-alt mr-1 text-primary"></i>
                                {_t(t("Report Type"))}
                              </label>
                              <div className="d-flex align-items-center">
                                <div className="form-check mr-4">
                                  <input
                                    type="radio"
                                    className="form-check-input pointer-cursor"
                                    id="detail"
                                    name="reportType"
                                    value="detail"
                                    onChange={(e) => handleSetType(e)}
                                    checked={reportOption === "detail"}
                                  />
                                  <label
                                    className="form-check-label pointer-cursor sm-text"
                                    htmlFor="detail"
                                  >
                                    <i className="fa fa-list mr-1 text-primary"></i>
                                    {_t(t("Detail"))}
                                  </label>
                                </div>
                                <div className="form-check">
                                  <input
                                    type="radio"
                                    className="form-check-input pointer-cursor"
                                    id="summary"
                                    name="reportType"
                                    value="summary"
                                    onChange={(e) => handleSetType(e)}
                                    checked={reportOption === "summary"}
                                  />
                                  <label
                                    className="form-check-label pointer-cursor sm-text"
                                    htmlFor="summary"
                                  >
                                    <i className="fa fa-th-list mr-1 text-primary"></i>
                                    {_t(t("Summary"))}
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div className="col-lg-5 col-md-3"></div>

                            <div className="col-lg-3 col-md-4 mb-2 text-right">
                              <button
                                className="btn btn-sm btn-primary  rounded"
                                onClick={(e) => getExcelReport()}
                              >
                                {t("Generate Report")}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <ReportExcelPrintGap
                        header={ reportOption === "summary" ? headerSummary : header}
                        generatedReport = {generatedReport}
                        heading={reportOption === "summary" ? "FG Purchase Summary Report" : "FG Purchase Detail Report"}
                        reportData={reportData}
                        startDate={startDate}
                        endDate={endDate}
                        componentRef={componentRef}
                        printRef={componentRefThermal}
                        branch={{
                          name: branch?.length ? branch.map((branh,i)=> branh.name + (i < branch?.length -1) ? ", " : "" ) : "All Branch",
                          show: true,
                        }}
                        type = {option}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
    </>
  );
};

export default FgPurchaseReport;
